/**
 * Кто на аватарке — человек или нет. Круглые аватарки только у людей; у приложений и ботов (как «Документы») — скруглённый
 * квадрат. Список пополняется там, где приходят люди пространства (`useMembers`), а `Avatar` сам смотрит в него
 * по id: ни одно из мест, где рисуется аватарка, ничего не передаёт и не может забыть про форму.
 */
const nonHuman = new Set<string>();

export function registerNonHumans(ids: Iterable<string>): void {
  for (const id of ids) nonHuman.add(id);
}

export function isNonHuman(userId: string): boolean {
  return nonHuman.has(userId);
}

/** Для тестов. */
export function resetNonHumans(): void {
  nonHuman.clear();
}

/** Заглавные с «хвостом» под строкой (Д, Ц, Щ, Q, J): их оптический центр выше геометрического, и они поднимаются на 1–2 px. */
export function hasTail(letter: string): boolean {
  return 'ДЦЩДцщQJ'.includes(letter.slice(0, 1).toUpperCase());
}
